import {createBaseShape} from './createBaseShape'

export const createText = (attrs) => {
  return Object.assign(createBaseShape(attrs), {
    enabledAnchors: ['middle-left', 'middle-right'],
    fontSize: 11,
    fill: 'black',
    padding: 10,
    align: 'center',
    name: 'text'
  })
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/createText.js